'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { SocialIcons } from '@eliadmin/core/src/components/header/social-icons';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { EliLogo } from '@eliadmin/core/src/components/footer/eli-logo';
import { HtmlDescription } from '../homepage/shared/html-description';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';

import { MdOutlineEmail, MdOutlinePhoneInTalk } from 'react-icons/md';
import { TrackedContactLink } from '../analytics/tracked-contact-link';

export const FoooterContentMobile = ({
  footerMenu,
  generalLayout,
}: {
  footerMenu: any;
  generalLayout: GeneralLayout;
}) => {
  const { t } = useTranslations();

  return (
    <>
      <div className="flex w-full flex-col items-start justify-start gap-4 md:hidden">
        <Image
          src={generalLayout.data.footer?.logo.url || ''}
          alt={resolveImageAlt(generalLayout?.data?.footer?.logo, generalLayout?.data?.contact?.company || '')}
          width={190}
          height={24}
        />
        <HtmlDescription color="white" content={generalLayout.data.footer?.text || ''} size="sm" />
      </div>
      <Accordion
        collapsible
        type="single"
        className="flex w-full flex-col items-start justify-start gap-0 border-t border-t-muted-foreground md:hidden"
      >
        {footerMenu.map((item: any) => (
          <AccordionItem
            key={item.name}
            value={item.name}
            className={cn('ea-footer__accordion-item')}
          >
            <AccordionTrigger className={cn('ea-footer__accordion-trigger')}>
              {item.name}
            </AccordionTrigger>
            <AccordionContent className={cn('ea-footer__accordion-content')}>
              {item.fields.map((field: any) => (
                <Link
                  key={field.name}
                  prefetch={false}
                  href={field.path ?? ''}
                  className="text-sm font-normal text-white"
                >
                  {field.name}
                </Link>
              ))}
            </AccordionContent>
          </AccordionItem>
        ))}
        <AccordionItem value="spolocnost" className={cn('ea-footer__accordion-item')}>
          <AccordionTrigger className={cn('ea-footer__accordion-trigger')}>
            {t('text1432')}
          </AccordionTrigger>
          <AccordionContent className={cn('ea-footer__accordion-content')}>
            <p className="text-sm font-normal text-white">{generalLayout.data.contact?.company}</p>
            <p className="text-sm font-normal text-white">{generalLayout.data.contact?.address}</p>
            <p className="text-sm font-normal text-white">
              {generalLayout.data.contact?.postcode} {generalLayout.data.contact?.city}
            </p>
            <p className="text-sm font-normal text-white">
              {t('text42')}: {generalLayout.data.contact?.ico}
            </p>
            <p className="text-sm font-normal text-white">
              {t('text43')}: {generalLayout.data.contact?.dic}
            </p>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="kontakty" className={cn('ea-footer__accordion-item')}>
          <AccordionTrigger className={cn('ea-footer__accordion-trigger')}>
            Kontakty
          </AccordionTrigger>
          <AccordionContent className={cn('ea-footer__accordion-content')}>
            <TrackedContactLink
              type="email"
              value={generalLayout.data.contact?.email}
              target="_blank"
              className="flex items-center justify-start gap-2 text-sm font-normal text-white"
            >
              <MdOutlineEmail size={20} />
              {generalLayout.data.contact?.email}
            </TrackedContactLink>
            <TrackedContactLink
              type="phone"
              value={generalLayout.data.contact?.phone}
              target="_blank"
              className="flex items-center justify-start gap-2 text-sm font-normal text-white"
            >
              <MdOutlinePhoneInTalk size={20} />
              {generalLayout.data.contact?.phone}
            </TrackedContactLink>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      <div className="flex flex-col items-center justify-center gap-8 md:hidden">
        <SocialIcons className={{ icon: 'h-5 w-5' }} />
        <div className="flex items-center justify-center gap-4">
          <Link
            prefetch={false}
            href={'/ochrana-osobnych-udajov'}
            className="text-sm font-normal text-muted-foreground"
          >
            {t('text1252')}
          </Link>
          <Link
            prefetch={false}
            href={'/cookies'}
            className="text-sm font-normal text-muted-foreground"
          >
            Cookies
          </Link>
        </div>
        <div className="flex w-full flex-col items-center justify-center gap-4">
          <p className="whitespace-nowrap text-sm font-normal text-muted-foreground">
            {`© ${new Date().getFullYear()} ${(generalLayout.data.site_name?.trim() || '')}. ${t('text640')}`}
          </p>
          <a
            href="https://elias-itsolutions.sk/"
            target="_blank"
            className={cn('w-full max-w-[250px]', 'ea-footer__eli-logo-link')}
          >
            <EliLogo />
          </a>
        </div>
      </div>
    </>
  );
};
